<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="users"
      fixed-header
      hide-default-footer
      class="elevation-4"
      :items-per-page="100"
      hide-default-header
    >
      <template v-slot:top>
        <div class="table-title">
          <span>Live Users</span>
          <span class="events-count"> ({{ users.length }}) </span>
        </div>
      </template>
      <template v-slot:[`item.nickname`]="{ item }">
        <live-user :item="item" :openUserPreviewModal="openUserPreviewModal" />
      </template>
    </v-data-table>
    <user-preview-modal
      :show="showUserPreviewModal"
      :item="selectedUser"
      :close="closeUserPreviewModal"
    />
  </div>
</template>

<script>
import LiveUser from "@/components/admin/events/LiveUser.vue";
import UserPreviewModal from "@/components/admin/users/userPreviewModal.vue";

export default {
  name: "LiveUsersTable",
  components: {
    LiveUser,
    UserPreviewModal,
  },
  props: {
    users: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    headers: [
      {
        text: "Live Users",
        align: "start",
        value: "nickname",
        sortable: false,
      },
    ],
    showUserPreviewModal: false,
    selectedUser: null,
    liveUsersIntervalId: null,
  }),
  created() {
    this.getLiveUsers();
  },
  beforeDestroy() {
    if (this.liveUsersIntervalId) {
      clearInterval(this.liveUsersIntervalId);
      this.liveUsersIntervalId = null;
    }
  },
  methods: {
    getLiveUsers() {
      // Initial fetch
      this.$store.dispatch("addLiveUsersListener", this.onLiveUsersChange);

      // Set up polling every 60 seconds if not already set
      if (!this.liveUsersIntervalId) {
        this.liveUsersIntervalId = setInterval(() => {
          this.$store.dispatch("addLiveUsersListener", this.onLiveUsersChange);
        }, 60000);
      }
    },
    onLiveUsersChange(newDocs) {
      this.$emit('update:users', newDocs);
    },
    openUserPreviewModal(user) {
      this.selectedUser = user;
      this.showUserPreviewModal = true;
    },
    closeUserPreviewModal() {
      this.showUserPreviewModal = false;
      this.selectedUser = null;
    },
  },
};
</script>

<style scoped>
.table-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  font-weight: bold;
  font-size: 16px;
  color: #3a3a3a;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #e4e4e4;
}

.events-count {
  color: #666;
  font-size: 14px;
  font-weight: normal;
}
</style> 